export const postulacionesStatistics = {
  empty: {
    title: 'Aún no tenemos información para mostrarte de este aviso.',
    subtitle: '¡Vuelve en otro momento!',
  },
}
